import styled from 'styled-components';
import { Text } from '@visx/text';
import type { TextProps } from '@/thirdparty/@vx/text';

export const Label = styled(Text)<TextProps>`
  font-size: 11px;
  fill: ${({ theme }) => theme.color.white};
`;
